import { mainSiteUrl } from '@/mocks/categories';

const finds = [
  {
    name: 'Nike Dunk Low',
    desc: 'Klasyczne sneakersy w limitowanej edycji',
    price: '$42',
    imageUrl: 'https://readdy.ai/api/search-image?query=Navy%20blue%20and%20white%20retro%20basketball%20sneakers%20being%20worn%20on%20city%20sidewalk%20crossing%2C%20denim%20jeans%20visible%2C%20motion%20blur%20background%20with%20yellow%20taxi%2C%20street%20style%20photography%2C%20urban%20commute%20scene%2C%20dynamic%20natural%20lighting&width=600&height=800&seq=finds-v2-01&orientation=portrait'
  },
  {
    name: 'Yeezy Slide',
    desc: 'Wygodne klapki w kolorze Bone',
    price: '$18',
    imageUrl: 'https://readdy.ai/api/search-image?query=Pair%20of%20sandal%20slides%20on%20wooden%20pool%20deck%20next%20to%20turquoise%20swimming%20pool%20water%20with%20sunlight%20reflections%2C%20tropical%20palm%20tree%20shadow%2C%20vacation%20resort%20lifestyle%20photography%2C%20summer%20relaxation%20vibe&width=600&height=800&seq=finds-v2-02&orientation=portrait'
  },
  {
    name: 'Essentials Hoodie',
    desc: 'Ciepła bluza w kolorze Taupe',
    price: '$35',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cozy%20oversized%20cream%20colored%20hoodie%20being%20held%20by%20someone%20sitting%20on%20window%20sill%20reading%20book%2C%20rainy%20day%20outside%20window%2C%20warm%20indoor%20lighting%2C%20candle%20and%20mug%20nearby%2C%20hygge%20comfort%20lifestyle%20photography&width=600&height=800&seq=finds-v2-03&orientation=portrait'
  },
  {
    name: 'Carhartt Jacket',
    desc: 'Klasyczna kurtka robocza Detroit',
    price: '$48',
    imageUrl: 'https://readdy.ai/api/search-image?query=Rugged%20olive%20green%20canvas%20work%20jacket%20slung%20over%20shoulder%20of%20person%20walking%20through%20autumn%20forest%20trail%2C%20golden%20fall%20leaves%2C%20soft%20backlight%20sun%20through%20trees%2C%20outdoor%20adventure%20lifestyle%2C%20cinematic%20nature%20photography&width=600&height=800&seq=finds-v2-04&orientation=portrait'
  },
  {
    name: 'Stussy T-Shirt',
    desc: 'Basic tee z logo 8 Ball',
    price: '$15',
    imageUrl: 'https://readdy.ai/api/search-image?query=Washed%20black%20graphic%20band%20style%20t-shirt%20draped%20over%20vintage%20record%20player%20turntable%20with%20vinyl%20records%20scattered%2C%20dim%20warm%20lamp%20light%2C%20retro%20music%20room%20aesthetic%2C%20nostalgic%20moody%20interior%20photography&width=600&height=800&seq=finds-v2-05&orientation=portrait'
  },
];

export default function ProductFinds() {
  return (
    <section className="w-full py-16 md:py-24 px-4 md:px-8 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-10">
          <div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950">
              Kakobuy Sheet <span className="text-primary-500">Finds</span>
            </h2>
            <p className="text-base text-foreground-500 mt-2">Sprawdzone produkty z bazy</p>
          </div>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            Zobacz wszystkie finds
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="flex gap-4 overflow-x-auto pb-4 -mx-4 px-4 md:mx-0 md:px-0">
          {finds.map((item, idx) => (
            <a
              key={idx}
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="group flex-shrink-0 w-[240px] md:w-[280px] rounded-lg overflow-hidden bg-background-50 cursor-pointer"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.name}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 right-3 px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-900 text-xs font-semibold">
                  {item.price}
                </span>
              </div>
              <div className="p-4">
                <h4 className="text-base font-semibold text-foreground-900 font-heading">{item.name}</h4>
                <p className="text-sm text-foreground-500 mt-1">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}